/* Lupin Gold reviews (replaces Judge.me, 04/10/2026): show more, photo lightbox, carousel buttons. No dependencies. */
(function () {
  function init(root) {
    root.querySelectorAll('.lgr-widget').forEach(function (w) {
      if (w.dataset.lgrReady) return; w.dataset.lgrReady = '1';
      var page = Number(w.dataset.lgrPage || 5);
      var more = w.querySelector('.lgr-more');
      if (more) more.addEventListener('click', function () {
        var hidden = w.querySelectorAll('.lgr-item[hidden]');
        for (var i = 0; i < hidden.length && i < page; i++) hidden[i].hidden = false;
        if (!w.querySelector('.lgr-item[hidden]')) more.remove();
      });
      var box = w.querySelector('.lgr-lightbox');
      if (!box || typeof box.showModal !== 'function') return;
      var img = box.querySelector('img');
      w.addEventListener('click', function (e) {
        var b = e.target.closest('.lgr-photo');
        if (!b) return;
        img.src = b.dataset.lgrFull; img.alt = (b.querySelector('img') || {}).alt || 'Customer photo';
        box.showModal();
      });
      box.querySelector('.lgr-lightbox__close').addEventListener('click', function () { box.close(); });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    });
    root.querySelectorAll('[data-lgr-carousel]').forEach(function (c) {
      if (c.dataset.lgrReady) return; c.dataset.lgrReady = '1';
      var track = c.querySelector('.lgr-carousel__track');
      function step(dir) { var card = track.querySelector('.lgr-card'); var w = card ? card.getBoundingClientRect().width + 16 : 300; track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
      var p = c.querySelector('.lgr-carousel__prev'), n = c.querySelector('.lgr-carousel__next');
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
      /* Dots and optional auto-advance (07/10/2026). Auto stops for good once the visitor touches it. */
      var dots = c.querySelector('.lgr-carousel__dots'), cards = track.querySelectorAll('.lgr-card');
      function current() { var w = cards[0] ? cards[0].getBoundingClientRect().width + 16 : 300; return Math.round(track.scrollLeft / w); }
      function mark() { if (!dots) return; var i = current(); dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
      if (dots && cards.length > 1) {
        for (var k = 0; k < cards.length; k++) dots.appendChild(document.createElement('i'));
        var tick = null; track.addEventListener('scroll', function () { if (tick) return; tick = requestAnimationFrame(function () { tick = null; mark(); }); }, { passive: true });
        mark();
      }
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (c.hasAttribute('data-lgr-auto') && !calm && cards.length > 1 && 'IntersectionObserver' in window) {
        var timer = null, seen = false, held = false, done = false;
        function go() { if (held || done || !seen) return; var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; if (end) track.scrollTo({ left: 0, behavior: 'smooth' }); else step(1); }
        function stop() { done = true; if (timer) clearInterval(timer); }
        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { c.addEventListener(ev, stop, { passive: true }); });
        c.addEventListener('mouseenter', function () { held = true; }); c.addEventListener('mouseleave', function () { held = false; });
        c.addEventListener('focusin', function () { held = true; }); c.addEventListener('focusout', function () { held = false; });
        new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0.4 }).observe(c);
        timer = setInterval(go, 5200);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
